export const EmployeeActionBarEN = {
    "employeeActionBar": {
        "tab": {
            "detail":"Information",
            "jobDetail":"Job",
            "contract":"Contract",
            "salary":"Salary & allowance",
            "admission":"Admission",
            "insurance":"Insurance",
            "decision":"Decision"
        }
    }
}